<svg
  [ngClass]="size + ' ' + color"
  class="cursor-pointer transition hover:text-gray-600 active:rotate-180"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg">

  <path
    d="M5.7998 11.5927C5.7998 12.739 6.13972 13.8595 6.77657 14.8126C7.41342 15.7657 8.3186 16.5086 9.37764 16.9473C10.4367 17.386 11.602 17.5007 12.7263 17.2771C13.8506 17.0535 14.8833 16.5015 15.6938 15.6909C16.5044 14.8804 17.0564 13.8476 17.28 12.7234C17.5037 11.5991 17.3889 10.4338 16.9502 9.37471C16.5115 8.31567 15.7687 7.41049 14.8156 6.77364C13.8625 6.13679 12.7419 5.79687 11.5956 5.79688C9.97532 5.80297 8.42013 6.4352 7.25519 7.56137L5.7998 9.01676"
    stroke="currentColor"
    stroke-width="1.28795"
    stroke-linecap="round"
    stroke-linejoin="round"/>

  <path
    d="M5.7998 5.79688V9.01676H9.01969"
    stroke="currentColor"
    stroke-width="1.28795"
    stroke-linecap="round"
    stroke-linejoin="round"/>
</svg>
